module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_3016.b6e3bbcf.png";